/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6accf94e&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/components/VabRefresh/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6accf94e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6accf94e', __exports__)) {
    api.reload('6accf94e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6accf94e&ts=true", () => {
    api.rerender('6accf94e', render)
  })

}


export default __exports__